import Vue from 'vue';
import VueRouter from 'vue-router';
import PageNotFound from './PageNotFound.vue';
import MAIN_COMPONENT_TANIEC_Z_GWIAZDAMI from '@/projects/taniec-z-gwiazdami/Main.vue';
import ROUTE_CHILDREN_TANIEC_Z_GWIAZDAMI from '@/projects/taniec-z-gwiazdami/routes';
import MAIN_COMPONENT_TYLKO_JEDEN from '@/projects/tylko-jeden/Main.vue';
import ROUTE_CHILDREN_TYLKO_JEDEN from '@/projects/tylko-jeden/routes';
import MAIN_COMPONENT_NINJA_WARRIOR from '@/projects/ninja-warrior/Main.vue';
import ROUTE_CHILDREN_NINJA_WARRIOR from '@/projects/ninja-warrior/routes';
import MAIN_COMPONENT_LOVE_ISLAND from '@/projects/love-island/Main.vue';
import ROUTE_CHILDREN_LOVE_ISLAND from '@/projects/love-island/routes';
import MAIN_COMPONENT_CZYSTA_POLSKA from '@/projects/czysta-polska/Main.vue';
import ROUTE_CHILDREN_CZYSTA_POLSKA from '@/projects/czysta-polska/routes';

Vue.use(VueRouter);

const routes = [
    {
        path: '/taniec-z-gwiazdami/',
        component: MAIN_COMPONENT_TANIEC_Z_GWIAZDAMI,
        children: ROUTE_CHILDREN_TANIEC_Z_GWIAZDAMI,
    },
    {
        path: '/tylko-jeden/',
        component: MAIN_COMPONENT_TYLKO_JEDEN,
        children: ROUTE_CHILDREN_TYLKO_JEDEN,
    },
    {
        path: '/ninja-warrior/',
        component: MAIN_COMPONENT_NINJA_WARRIOR,
        children: ROUTE_CHILDREN_NINJA_WARRIOR,
    },
    {
        path: '/love-island/',
        component: MAIN_COMPONENT_LOVE_ISLAND,
        children: ROUTE_CHILDREN_LOVE_ISLAND,
    },
    {
        path: '/czysta-polska/',
        component: MAIN_COMPONENT_CZYSTA_POLSKA,
        children: ROUTE_CHILDREN_CZYSTA_POLSKA,
    },
    {
        path: '*',
        component: PageNotFound,
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    document.title = (to.meta && to.meta.title) || '';
    next();
});

export default router;
